export default "__VITE_ASSET__B63slI1r__"